<div class="w-100 bg-grey-200">
  <div class="pt-3 pb-4 d-none d-lg-flex position-relative justify-content-center lazy-leaderboard-container">
    <flo-lazy
      [componentConstructor]="AdComponent"
      [initialProps]="leaderboardLarge"
      [detectorHeight]="90"
    ></flo-lazy>
  </div>
  <div
    class="pt-3 pb-4 d-none d-md-flex d-lg-none justify-content-center position-relative lazy-leaderboard-container">
    <flo-lazy
      [componentConstructor]="AdComponent"
      [initialProps]="leaderboardSmall"
      [detectorHeight]="90"
    ></flo-lazy>
  </div>
  <main class="container min-vh-100 py-0 px-0 bg-grey-200">
    <ng-container *ngIf="scheduleLayout$ | async as scheduleLayout">
      <div class="py-3 px-3 px-lg-4 w-100 bg-white">
        <h1 class="h3 mb-0" data-test="schedule-title">{{ scheduleLayout.title ?? 'Schedule' }}</h1>
      </div>
      <div class="w-100 py-0 px-0 px-sm-3 px-lg-4 pb-35 bg-white">
        <flo-event-list-controls
          [tabItems]="scheduleLayout?.tabs"
          [searchTerm]="searchQueryParam$ | async"
          [calendarAction]="scheduleLayout.calendarAction"
          [dateSelected]="dateQueryParams$ | async"
          [filtersSection]="filters$ | async"
          [clearAll]="clearAll$ | async"
          (navigateToTab)="navigateToTab($event)"
          (search)="updateSearchQueryParam($event)"
          (singleFilterClicked)="singleFilterClicked($event)"
          [toggleFilter]="scheduleLayout?.onlyFavorites"
        >
        </flo-event-list-controls>
      </div>

      <ng-container *ngIf="isFilterOrSearchLoading$ | async; else scheduleSection">
        <div class="py-4 px-3 px-lg-4 bg-white min-vh-100">
          <div class="d-flex spinner-container">
            <div class="spinner-border text-light d-flex m-auto"></div>
          </div>
        </div>
      </ng-container>

      <ng-template #scheduleSection>
        <div *ngIf="tableDataWithPagination$ | async as tableData" class="bg-white min-table-height">
          <div class="w-100 pb-35" *ngFor="let datum of tableData;
              let i = index;
              let last = last;
              trackBy: trackById">

            <ng-container *ngIf="datum.type === 'message'">
              <div class="py-4 px-3 px-lg-4">
                <flo-message [message]="datum"></flo-message>
              </div>
            </ng-container>
            <ng-container *ngIf="datum.type === 'collection'">
              <div class="px-0 px-sm-3 px-lg-4" [ngClass]="{'pb-4': (i > 0 && ((i + 1)%10 === 0) || (i > 0 && ((i + 1)%10) > 3 && last))}">
                <flo-section-table [section]="datum"></flo-section-table>
              </div>
              <ng-container *ngIf="(i > 0 && (((i + 1) % 10) === 0) || (i > 0 && ((i + 1)%10) > 3 && last))">
                <div
                  class="d-none d-lg-flex w-100 bg-grey-200 flex-row justify-content-center py-4"
                  data-test="schedule-inline-ad-slot">
                  <flo-lazy
                    [componentConstructor]="AdComponent"
                    [initialProps]="leaderboardLargeBTF"
                    [detectorHeight]="90"
                  ></flo-lazy>
                </div>
                <div
                  class="d-none d-md-flex d-lg-none w-100 bg-grey-200 flex-row justify-content-center py-4"
                  data-test="schedule-inline-ad-slot">
                  <flo-lazy
                    [componentConstructor]="AdComponent"
                    [initialProps]="leaderboardSmallBTF"
                    [detectorHeight]="90"
                  ></flo-lazy>
                </div>
                <div
                  class="d-flex d-md-none w-100 bg-grey-200 flex-row justify-content-center py-4"
                  data-test="schedule-inline-ad-slot">
                  <flo-lazy
                    [componentConstructor]="AdComponent"
                    [initialProps]="rectangleSmallBTF"
                    [detectorHeight]="90"
                  ></flo-lazy>
                </div>
              </ng-container>
            </ng-container>
            <!-- infinite scroll -->
            <!-- this should always be under the view components, like table -->
            <ng-container *ngIf="datum.type === 'link' && datum.style === 'paginate'">
              <div
                data-test="container-pagination-spinner"
                class="d-flex spinner-container w-100"
              >
                <div class="spinner-border text-light d-flex m-auto"></div>
              </div>
              <div
                floElementIsVisible
                [valueToOutput]="datum"
                (elementIsVisible)="emitNextPage($event)"
              ></div>
            </ng-container>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </main>
</div>
